import {type FC, type HTMLProps, memo} from 'react';

import classNames from 'classnames';

import styles from './Button.module.css';

interface Props extends HTMLProps<HTMLButtonElement> {
  type?: 'button' | 'reset' | 'submit';
}

const Button: FC<Props> = props => (
  <button
    {...props}
    className={classNames(
      'Button',
      styles.Button,
      props.className,
      props.disabled && styles.disabled,
    )}
  />
);

export default memo(Button);
